import React, { useState } from "react";
import styled from "styled-components";
import _ from "lodash";
import Button from "@mui/material/Button";

import theme from "../../styles/theme";
import { DriverStandingsItemSkeleton } from "./DriverStandingsItem";
import { useStandingsContext } from "../../contexts/standings";
import { useScheduleContext } from "../../contexts/schedule";
import SeasonTable from "../SeasonTable/SeasonTable";
import { getDivisionColor, getDivisionTextColor, getDivisionPriority } from "../../utils/helpers/divisionUtils";

const StandingsContainer = styled.div`
  padding: 4px 0px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledButton = styled(Button)`
  margin: auto !important;
  font-family: "Roboto Condensed" !important;
  font-weight: bold !important;
  width: 200px;

  &:hover {
    background-color: ${theme.colors.white}20 !important;
  }
`;

const DivisionBadge = styled.span`
  background-color: ${(props) => props.$color || "transparent"};
  color: ${(props) => props.$textColor || theme.colors.grey};
  padding: ${(props) => (props.$color ? "4px 8px" : "4px 0")};
  font-size: 14px;
  font-weight: bold;
  border-radius: 4px;
  text-transform: uppercase;
  font-family: "Roboto Condensed", sans-serif;
  margin-top: 16px;
  margin-bottom: 8px;
  align-self: flex-start;
`;

const DriverStandings = ({ seasonId, selectedDivision }) => {
  const { standings } = useStandingsContext();
  const { seasons } = useScheduleContext();
  const [all, setAll] = useState(false);

  const driversMap = standings[seasonId]?.drivers;
  const divisionColors = seasons[seasonId]?.divisionColors;

  if (!driversMap) {
    return (
      <StandingsContainer>
        {_.times(10, (i) => <DriverStandingsItemSkeleton key={i} />)}
      </StandingsContainer>
    );
  }

  const divisions = Object.keys(driversMap).sort((a, b) => getDivisionPriority(divisionColors, a) - getDivisionPriority(divisionColors, b));
  const isMultiDivision = divisions.length > 1 && !selectedDivision;
  const divisionsToRender = selectedDivision && driversMap[selectedDivision] ? [selectedDivision] : divisions;

  return (
    <StandingsContainer style={{ gap: isMultiDivision ? "24px" : "8px" }}>
      {divisionsToRender.map((division) => {
        const list = driversMap[division] || [];
        const slicedDrivers = list.slice(0, all ? 50 : 20);
        const divisionColor = getDivisionColor(divisionColors, division);

        return (
          <div key={division} style={{ display: "flex", flexDirection: "column" }}>
            {isMultiDivision && (
              <DivisionBadge
                $color={divisionColor}
                $textColor={divisionColor ? getDivisionTextColor(divisionColor) : undefined}
              >
                {division}
              </DivisionBadge>
            )}
            <SeasonTable drivers={slicedDrivers} seasonId={seasonId} />

            {list.length > 20 && !all && (
              <div style={{ display: "flex", marginTop: 8 }}>
                <StyledButton
                  size="small"
                  sx={{
                    color: theme.colors.white,
                  }}
                  onClick={() => setAll(true)}
                >
                  Переглянути всю таблицю
                </StyledButton>
              </div>
            )}
          </div>
        );
      })}
    </StandingsContainer>
  );
};

export default DriverStandings;
